<template>
  <VueDatePicker :key="datePickerKey" class="hrm_range_picker" :ui="{ menu: 'hrm_range_picker_menu' }"
    v-model="pickerDate" :enable-time-picker="false" :format="format" :preset-dates="presetDates"
   :min-date="computedMinDate"
    :placeholder="placeholder" :position="pickerPosition" :teleport="true" range :multi-calendars="multiCalander"
    auto-apply @update:model-value="selectedDate" :hide-input-icon="hideInputIcon">
    <template #preset-date-range-button="{ label, value, presetDate }" v-if="calendarIcon == false">
      <span role="button" :tabindex="0" @click="presetDate(value)" @keyup.enter.prevent="presetDate(value)"
        @keyup.space.prevent="presetDate(value)">
        {{ label }}
      </span>
    </template>

    <template #trigger v-else>
      <button class="p-2 rounded border border-[#4A4A4A]" type="button" :class="placeholder ? 'flex gap-2' : ''">
        <Icon icon="bx:calendar" width="16" height="16" />
        <div class="text-[#CDCDCD] text-xs font-semibold">
          {{ placeholder }}
        </div>
      </button>
    </template>
  </VueDatePicker>
</template>
<script setup>
import VueDatePicker from "@vuepic/vue-datepicker";
import { ref, defineEmits, onMounted, computed } from 'vue';
import { startOfWeek, endOfWeek, startOfMonth, endOfMonth, startOfYear, endOfYear, subDays, subMonths, subYears, addYears, addMonths, subWeeks, addWeeks } from 'date-fns';
import { Icon } from "@iconify/vue";

const props = defineProps({
  pickerPosition: {
    type: String,
    default: 'center'
  },
  calendarIcon: {
    type: Boolean,
    default: false
  },
  placeholder: {
    type: String,
    default: 'Select date range'
  },
  startDate: {
    type: String,
  },
  endDate: {
    type: String,
  },
  multiCalander: {
    type: Boolean,
    default: true
  },
  hideInputIcon: {
    type: Boolean,
    default: true
  },
 minDate: {
    type: [Date, String, Number],
    default: null
  }
})
const emits = defineEmits('getDateRange')
const pickerDate = ref();
const datePickerKey = ref(1);

const presetDates = ref([
  { label: 'Yesterday', value: [subDays(new Date(), 1), subDays(new Date(), 1)] },
  { label: 'Today', value: [new Date(), new Date()] },

  {
    label: 'Last month',
    value: [startOfMonth(subMonths(new Date(), 1)), endOfMonth(subMonths(new Date(), 1))],
  },
  { label: 'This month', value: [startOfMonth(new Date()), endOfMonth(new Date())] },
  {
    label: 'Next month', value: [
      startOfMonth(addMonths(new Date(), 1)),
      endOfMonth(addMonths(new Date(), 1))
    ]
  },

  // Previous year
  { label: 'Last year', value: [startOfYear(subYears(new Date(), 1)), endOfYear(subYears(new Date(), 1))] },
  { label: 'This year', value: [startOfYear(new Date()), endOfYear(new Date())] },
  { label: 'Next year', value: [startOfYear(addYears(new Date(), 1)), endOfYear(addYears(new Date(), 1))] },

  { label: 'Last week', value: [startOfWeek(subWeeks(new Date(), 1)), endOfWeek(subWeeks(new Date(), 1))] },
  { label: 'This week', value: [startOfWeek(new Date()), endOfWeek(new Date())] },
  { label: 'Next week', value: [startOfWeek(addWeeks(new Date(), 1)), endOfWeek(addWeeks(new Date(), 1))] },
]);

const format = (date) => {
  if (!date) return false;
  const startDay = date[0].getDate().toString().padStart(2, '0');
  const startMonth = (date[0].getMonth() + 1).toString().padStart(2, '0');
  const startYear = date[0].getFullYear();

  const endDay = date[1].getDate().toString().padStart(2, '0');
  const endMonth = (date[1].getMonth() + 1).toString().padStart(2, '0');
  const endYear = date[1].getFullYear();

  return `${startYear}-${startMonth}-${startDay} To ${endYear}-${endMonth}-${endDay}`;
}

const selectedDate = (date) => {
  if (!date) {
    emits('getDateRange', null);
  } else {
    const startDay = date[0].getDate().toString().padStart(2, '0');
    const startMonth = (date[0].getMonth() + 1).toString().padStart(2, '0');
    const startYear = date[0].getFullYear();

    const endDay = date[1].getDate().toString().padStart(2, '0');
    const endMonth = (date[1].getMonth() + 1).toString().padStart(2, '0');
    const endYear = date[1].getFullYear();

    const dateData = {
      startDate: `${startYear}-${startMonth}-${startDay}`,
      endDate: `${endYear}-${endMonth}-${endDay}`
    }
    emits('getDateRange', dateData);
  }
}

const clearAndEmit = () => {
  pickerDate.value = null;
  datePickerKey.value += 1;
  emits('getDateRange', null);
}

const computedMinDate = computed(() => {
  if (!props.minDate) return null

  if (props.minDate instanceof Date) {
    return props.minDate
  }

  return new Date(props.minDate)
})
onMounted(() => {
  if (props.startDate && props.endDate) {
    pickerDate.value = [new Date(props.startDate), new Date(props.endDate)];
  }
})

</script>

<style>
.hrm_range_picker .dp--clear-btn {
  margin-right: 10px !important;
}

.hrm_range_picker_menu .dp--preset-dates {
  width: 200px !important;
}

.hrm_range_picker_menu .dp--preset-dates button {
  font-size: 14px !important;
  font-weight: bold !important;
  padding: 3px 10px !important;
}

.bgColor {
  background-color: var(--hrm_Theme_Bg_Color) !important;
}
</style>